export const calculateRes = (dateOfBirth) => {
  if (!dateOfBirth) return 0;

  const birthDate = new Date(dateOfBirth);
  const today = new Date();

  let residentYears = today.getFullYear() - birthDate.getFullYear();

  // Adjust age if birthday hasn't occurred this year
  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate())
  ) {
    residentYears--;
  }

  return residentYears;
};
